<template>
  <div class="page-container pt-0">
    <div class="backbtn-container">
      <router-link to="/my-office">
        <div class="back-btn mr-3">
          <v-icon class="pointer-events-none">mdi-arrow-left</v-icon>
        </div>
      </router-link>
      <span class="p-0">{{ this.$t("addProduct") }}</span>
    </div>
    <div class="wrappers">
      <ValidationObserver ref="observerproduct">
        <form @submit.prevent="submitFormProductCreate">
          <div class="main-container">
            <div class="w-50">
              <div class="Field">
                <span class="title">{{ this.$t("name") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("productName") }}</span>
                  <ValidationProvider
                    :name="this.$t('productName')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <input
                      type="text"
                      v-model="productName"
                      placeholder="-"
                      :class="{ errorInput: !!errors[0] }"
                      style="width: 100%"
                    />
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="Field">
                <span class="title">{{
                  this.$t("productCharacteristics")
                }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("description") }}</span>
                  <ValidationProvider
                    :name="this.$t('description')"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <textarea
                      style="width: 100%"
                      :class="{ errorInput: !!errors[0] }"
                      v-model="description"
                    ></textarea>
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div class="text-field">
                  <span class="label">{{ this.$t("quantityProducts") }}</span>
                  <ValidationProvider
                    :name="this.$t('quantityProducts')"
                    rules="required|numeric"
                    v-slot="{ errors }"
                  >
                    <input
                      type="number"
                      min="1"
                      v-model="quantity"
                      style="width: 100%"
                      placeholder="-"
                      :class="{ errorInput: !!errors[0] }"
                    />
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="Field">
                <span class="title">{{ this.$t("categoryProduct") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("category") }}</span>
                  <!-- Add ValidationProvider for category if needed -->
                  <ValidationProvider
                    rules="required"
                    :name="this.$t('category')"
                    v-slot="{ errors }"
                  >
                    <div class="category_container">
                      <vue-select
                        :class="{ errorSelect: !!errors[0] }"
                        ref="ProductSelectRef"
                        infinite
                        :name="$t('measure')"
                        @changeText="debouncedCategorySearchByName"
                        @changeText2="setSearchValue"
                        @input="clearSelectedCategory"
                        v-model="selectedCategory"
                        :items="categoryList"
                        clearable
                        :itemText="`name_${$i18n.locale}`"
                        class="user_input no-margin"
                        style="flex-grow: 1"
                      ></vue-select>
                      <button
                        type="button"
                        class="btn add"
                        @click="dialog = true"
                      >
                        +
                      </button>
                    </div>
                    <span class="error-text">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="w-50">
              <div class="Field" style="margin-bottom: 30px">
                <span class="title">{{ this.$t("productPhotos") }}</span>
                <div class="text-field">
                  <span class="label">{{ this.$t("uploadPhoto") }}</span>
                  <label
                    for="file-upload"
                    class="custom-file-upload"
                    :class="{ disabled: isInputDisable }"
                  >
                    <span>Upload file</span>
                    <input
                      id="file-upload"
                      type="file"
                      :disabled="isInputDisable"
                      accept="image/jpeg, image/png"
                      multiple
                      @change="previewFiles"
                    />
                    <vue-icon icon="FolderIcon" class="iconUploadBtn" />
                  </label>
                </div>
                <transition-group
                  v-if="uploadedImages.length"
                  tag="div"
                  name="fade"
                  class="image-preview-container"
                >
                  <div
                    v-for="(image, index) in uploadedImages"
                    :key="index"
                    class="image-preview-box"
                  >
                    <img :src="image.url" alt="Preview" />
                    <span class="delete-icon" @click="deleteImage(index)">
                      <vue-icon icon="deletePhoto" />
                    </span>
                  </div>
                </transition-group>
                <!-- <div v-else class="image-preview-box">
                    <img :src="NoImg" />
                  </div> -->
              </div>
              <div class="Field">
                <span class="title">{{ this.$t("productCondition") }}</span>
                <div class="container-radios">
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          value="NEW"
                          v-model="selectedOption"
                        />
                        {{ this.$t("NEW") }}
                      </label>
                    </ValidationProvider>
                  </div>
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          v-model="selectedOption"
                          value="SECOND_HAND"
                        />
                        {{ this.$t("used") }}
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
              <div class="Field">
                <span class="title">{{ this.$t("type") }}</span>
                <div class="container-radios">
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          value="FOR_USE"
                          v-model="selectedOptionForType"
                        />
                        {{ this.$t("foruse") }}
                      </label>
                    </ValidationProvider>
                  </div>
                  <div class="radio-div">
                    <ValidationProvider rules="required">
                      <label>
                        <input
                          type="radio"
                          v-model="selectedOptionForType"
                          value="FOR_REALIZATION"
                        />
                        {{ this.$t("forrealization") }}
                      </label>
                    </ValidationProvider>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="footer__action">
            <router-link to="/my-office">
              <button class="cancel btn">{{ this.$t("cancel") }}</button>
            </router-link>
            <v-btn class="add btn" :loading="isLoading" type="submit">
              {{ this.$t("add") }}
            </v-btn>
          </div>
        </form>
      </ValidationObserver>
    </div>
    <v-dialog v-model="dialog" max-width="400px">
      <div class="model_container">
        <span>
          <span class="title">{{ this.$t("addCategory") }}</span>
          <div @click="closeModal">
            <vue-icon
              icon="newBoldCloseIcon"
              style="cursor: pointer"
            ></vue-icon>
          </div>
        </span>
        <ValidationObserver ref="observer">
          <form @submit.prevent="handleSubmit" style="width: 100%">
            <div class="modalForm">
              <label>
                {{ this.$t("nameCategory") }} (Ру)
                <ValidationProvider
                  name="nameRu"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameRu"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("nameCategory") }} (O’z)
                <ValidationProvider
                  name="nameUz"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameUz"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <label>
                {{ this.$t("nameCategory") }} (Eng)
                <ValidationProvider
                  name="nameEng"
                  rules="required"
                  v-slot="{ errors }"
                  style="
                    display: flex;
                    flex-direction: column;
                    align-items: flex-start;
                  "
                >
                  <input
                    v-model="nameEng"
                    :class="{ errorInput: !!errors[0] }"
                  />
                  <span class="error-text">{{ errors[0] }}</span>
                </ValidationProvider>
              </label>
              <v-btn type="submit" class="add btn" :loading="isLoading">
                {{ this.$t("add") }}
              </v-btn>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { debounce } from "../../../../utils/pureFunctions";
import VueSelect from "../../../../components/ui/vue-select/VueSelect.vue";

export default {
  components: { VueSelect },
  data() {
    return {
      productName: "",
      description: "",
      quantity: "",
      isLoading: false,
      nameRu: "",
      nameUz: "",
      nameEng: "",
      dialog: false,
      uploadedImages: [],
      categoryList: [],
      categorySearchText: null,
      selectedOption: "NEW",
      selectedOptionForType: "FOR_USE",
      selectedCategory: null,
    };
  },
  methods: {
    submitFormProductCreate() {
      this.isLoading = true;
      this.$refs.observerproduct.validate().then(async (success) => {
        if (success) {
          const formData = new FormData();
          formData.append("name", this.productName);
          formData.append("description", this.description);
          formData.append("count", this.quantity);
          formData.append("categoryId", this.selectedCategory);
          formData.append("status", this.selectedOption);
          formData.append("type", this.selectedOptionForType);
          for (const image of this.uploadedImages) {
            formData.append("files", image.file);
          }

          await this.createProduct(formData);
          this.isLoading = false;
          this.$refs.observerproduct.reset();
        }
      });
    },
    async createProduct(formData) {
      try {
        this.showLoading();
        await this.$http.post("/office-product/save", formData);
        this.setSuccess({ text: this.$t("successfullySaved") });
        this.productName = "";
        this.description = "";
        this.quantity = "";
        this.uploadedImages = [];
        this.selectedCategory = null;
      } catch (e) {
        console.log(e);
      } finally {
        this.clearLoading();
        window.location.href = "/my-office";
      }
    },
    handleSubmit() {
      this.$refs.observer.validate().then((result) => {
        if (result) {
          const formValues = {
            name_en: this.nameEng,
            name_ru: this.nameRu,
            name_uz: this.nameUz,
            name_uzl: this.nameUz,
            forOffice: true,
          };

          this.categoryCreate(formValues);
          this.$refs.observer.reset();
        }
      });
    },
    clearSelectedCategory(value) {
      console.log(value);
    },
    setSearchValue(value) {
      this.categorySearchText = value;
    },
    async categorySelectSearch() {
      const value = this.categorySearchText?.trim();
      if (value === "") {
        this.categorySearchText = null;
      } else {
        this.categorySearchText = value;
      }
      await this.getCategoryList();
    },
    async categoryCreate(form) {
      this.isLoading = true;
      try {
        await this.$http.post("product-type/save", form);
        this.setSuccess({ text: this.$t("successfullySaved") });
        await this.getCategoryList();
        this.dialog = false;
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
        this.nameEng = "";
        this.nameRu = "";
        this.nameUz = "";
      }
    },
    async getCategoryList() {
      try {
        const {
          data: { data },
        } = await this.$http.get(`product-type/list`, {
          params: {
            page: 0,
            limit: 0,
            name: this.categorySearchText,
            forOffice: true,
          },
        });
        this.categoryList = data;
      } catch (e) {
        console.log(e);
      }
    },
    previewFiles(event) {
      const files = event.target.files;
      for (let i = 0; i < files.length; i++) {
        if (i >= 4) {
          break;
        }
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadedImages.push({ url: e.target.result, file: files[i] });
        };
        reader.readAsDataURL(files[i]);
      }
    },
    deleteImage(index) {
      this.uploadedImages.splice(index, 1);
    },
    closeModal() {
      this.dialog = false;
    },
  },
  computed: {
    isInputDisable() {
      return this.uploadedImages.length >= 4;
    },
    debouncedCategorySearchByName() {
      return debounce(this.categorySelectSearch, 300);
    },
  },
  created() {
    this.getCategoryList();
  },
};
</script>

<style lang="scss" scoped>
.errorInput {
  border-color: red;
  -webkit-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  -moz-box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
  box-shadow: inset 3px 0px 63px -31px rgba(255, 0, 0, 0.355);
}
.error-text {
  height: 10px;
  font-size: 12px;
  color: red;
  font-family: "Rubik", sans-serif;
  margin-top: 5px;
}
.main-container {
  display: flex;
  gap: 32px;
}

.w-50 {
  width: 50%;
}

.backbtn-container {
  display: flex;
  align-items: center;
  gap: 3px;
}

.back-btn {
  background-color: #fff;
  border-radius: 6px;
  display: inline-block;
  padding: 4px;
  transition: 0.4s ease;
  border: 1px solid #dfe2e9;
  box-shadow: 0px 1px 2px 0px #0e31581a;
  &:hover {
    border-color: #0096b2;
  }
}

.wrappers {
  background-color: #fff;
  border-radius: 6px;
  padding: 24px;
  margin-top: 24px;
  border-radius: 6px;
}

input,
textarea {
  background-color: #fafbfc;
  border-radius: 5px;
  border: 1px solid #dfe2e9;
  outline: none;
  padding: 6px;
}

.title {
  font-family: "Rubik", sans-serif;
  font-size: 18px;
  font-weight: 600;
  line-height: 21.09px;
  color: #303d4d;
}

input:disabled {
  cursor: not-allowed;
}

.label {
  font-family: "Rubik", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 14.22px;
  text-align: left;
}

.Field {
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
}

.text-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.custom-file-upload {
  display: block;
  position: relative;
}

.custom-file-upload.disabled span,
.custom-file-upload.disabled {
  cursor: not-allowed;
}

.custom-file-upload input[type="file"] {
  display: none;
}

.custom-file-upload span {
  display: block;
  padding: 6px 10px;
  background: transparent;
  border: 1px dashed #dfe2e9;
  color: #a2a5b9;
  cursor: pointer;
  border-radius: 4px;
}

.iconUploadBtn {
  position: absolute;
  right: 10px;
  bottom: 11px;
}

.image-preview-container {
  display: flex;
  flex-wrap: wrap;
}

.image-preview-box {
  position: relative;
  width: 124px;
  height: 124px;
  margin: 10px;
  border: 1px dashed #dfe2e9;
  border-radius: 5px;
  padding: 5px;
}

.image-preview-box img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
  color: red;
  font-size: 16px;
}

/* Style for when hovering over the upload button */
//.custom-file-upload span:hover {
//  background: #0056b3;
//}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.radio-div {
  display: flex;
  align-items: center;
  gap: 15px;
}

.container-radios {
  display: flex;
  gap: 20px;
}

.footer__action {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid #e0e0e0;
  padding-top: 14px;
}

.btn {
  padding: 6px 12px;
  border-radius: 6px;
}

.btn.cancel {
  background-color: #dfe2e9;
  color: #7a889b;
}

.btn.add {
  background-color: #0096b2;
  color: #fff;
}

.category_container {
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
}

.model_container {
  background-color: #fff;
  padding: 24px;

  span {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .modalForm {
    display: flex;
    flex-direction: column;
    gap: 18px;
    margin-top: 20px;

    input {
      width: 100%;
    }
  }
}

.errorSelect .vue-select__wrap .vue-select__input {
  border: 1px solid red !important;
}
</style>
